/**
 * DataLayer component that renders a Geojson layer with the passed data and styles.
 */

import React from 'react';
import { GeojsonLayerRaw } from './GeojsonLayer';
import * as Topojson from 'topojson';
import wrapDataLayer from './Utils/Wrapper';


class TopojsonLayer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
  	const geojsonData = Topojson.feature(this.props.config, this.props.config.objects.collection);

  	const features = [];
  	features.push(geojsonData.features[this.props.featureIndex]);

  	const data = {
  		type: "FeatureCollection",
  		features: features,
  	};

  	return (
	    <GeojsonLayerRaw
	      config={{ data: data, style: this.props.style }} />
	);
  }

}


export { TopojsonLayer as GeojsonLayerRaw };
export default wrapDataLayer(TopojsonLayer);



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/TopojsonLayer.js
 **/